import useFeatureFlags from '@modules/core/hooks/useFeatureFlags';
import { ReactNode } from 'react';

export const BehindMaintenance = ({ children }: { children: ReactNode }) => {
  const { isFeatureFlagsLoading, isFeatureActive } = useFeatureFlags();

  if (!isFeatureFlagsLoading && isFeatureActive('system.maintenanceMode')) {
    window.location.replace('/maintenance');
    return;
  }

  return children;
};
